import FeatureFlag from "models/interfaces/feature-flag";
import { useCallback } from "react";
import { FeatureFlagScopeType } from "utilities/enumerations/feature-flag-scope-type";
import FeatureFlagsService from "utilities/services/feature-flags/feature-flags-service";
import ScopedFeatureFlagsService from "utilities/services/feature-flags/scoped-feature-flags-service";
import { ToastManager } from "utilities/toast/toast-manager";

export default function useUpdateFeatureFlag() {
    const updateFeatureFlag = useCallback(
        async ({ name, isEnabled }: FeatureFlag) => {
            if (!name) {
                ToastManager.error("Feature flag name is required.");
                return;
            }

            if (typeof isEnabled !== "boolean") {
                ToastManager.error("Feature flag isEnabled must be a boolean.");
                return;
            }

            try {
                await FeatureFlagsService.update({ name }, { isEnabled });
            } catch (error) {
                ToastManager.error("Failed to update feature flag");
            }
        },
        []
    );

    const updateScopedFeatureFlag = useCallback(
        async (
            { name, isEnabled }: FeatureFlag,
            scopeType: FeatureFlagScopeType
        ) => {
            if (!name) {
                ToastManager.error("Feature flag name is required.");
                return;
            }

            if (typeof isEnabled !== "boolean") {
                ToastManager.error("Feature flag isEnabled must be a boolean.");
                return;
            }

            try {
                await ScopedFeatureFlagsService.update(
                    { name },
                    { isEnabled, scopeType }
                );
            } catch (error) {
                ToastManager.error("Failed to update feature flag");
            }
        },
        []
    );

    return {
        updateFeatureFlag,
        updateScopedFeatureFlag,
    };
}
